import React from 'react';

import './style.css';

/** Collapse toggler button on the header. */
const MenuButton: React.FC = () => {
  return (
    <button
      className="navbar-toggle collapsed"
      type="button"
      aria-label="Menu"
      data-toggle="collapse"
      data-target="#navbar"
      aria-expanded="false"
      aria-controls="navbar"
    >
      <span className="icon-bar" />
      <span className="icon-bar" />
      <span className="icon-bar" />
    </button>
  );
};

export default MenuButton;
